'use client'

import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

interface LeadSuccessProps {
  title: string
  children: ReactNode
  onReset?: () => void
  resetLabel?: string
  actions?: ReactNode
}

/** Post-submit state shared by the contact, quote, and warranty forms. */
export function LeadSuccess({ title, children, onReset, resetLabel = 'Send another', actions }: LeadSuccessProps) {
  return (
    <div className="rounded-2xl border border-border bg-surface p-8 text-center" role="status" aria-live="polite">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-success/15 text-success">
        <Icon icon="check-circle" className="text-2xl" aria-hidden="true" />
      </div>
      <h2 className="mb-2 text-xl font-bold text-foreground">{title}</h2>
      <div className="mx-auto mb-5 max-w-md space-y-2 text-sm text-muted">{children}</div>
      <div className="flex flex-wrap justify-center gap-3">
        {actions}
        {onReset && (
          <Button variant="outline" onPress={onReset}>
            {resetLabel}
          </Button>
        )}
      </div>
    </div>
  )
}
